import {
  QueryClientProvider,
  ReactQueryDevtools,
  createQueryClient,
} from "checkout-query-client/main";
import { AppContextWrapper } from "checkout-query-client/providers/app-context-wrapper";

import { InitWrapper } from "drop-in-ui/components/init-wrapper/init-wrapper";
import { InitParams } from "drop-in-ui/components/init-wrapper/types";
import {
  API_ROOT,
  DEVICE_FINGERPRINT_SDK,
  GOOGLE_PAY_ENV,
  KOUNT_SESSION_HOSTNAME,
  PAZE_SDK,
  TARGET,
} from "drop-in-ui/utils/configs";
import { VERSION } from "drop-in-ui/utils/version/version";

/**
 * The goal of this function is to call the merchant config and provide the required information to the checkout form
 */
export function InitWrapperWithProvider({
  checkoutSessionToken,
  themeValueOverrides,
  controlledSubmit,
  i18nInstance,
  iframePayDomain,
}: InitParams) {
  const queryClient = createQueryClient();

  return (
    <AppContextWrapper
      value={{
        checkoutSessionToken,
        controlledSubmit,
        apiHost: API_ROOT,
        version: VERSION,
        target: TARGET,
        kountSessionHostname: KOUNT_SESSION_HOSTNAME,
        experienceType: "dropInUI",
        paymentRequirements: {},
        paymentMessages: {},
        googlePayEnv: GOOGLE_PAY_ENV,
        pazeSDK: PAZE_SDK,
        deviceFingerprintSDK: DEVICE_FINGERPRINT_SDK,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <InitWrapper
          themeValueOverrides={themeValueOverrides}
          i18nInstance={i18nInstance}
          iframePayDomain={iframePayDomain}
        />
        <ReactQueryDevtools />
      </QueryClientProvider>
    </AppContextWrapper>
  );
}
